// extracted by mini-css-extract-plugin
var _1 = "_tabSelector-module__active";
var _2 = "_tabSelector-module__container";
var _3 = "_tabSelector-module__content-container";
var _4 = "_tabSelector-module__overflow-container";
var _5 = "_tabSelector-module__tab";
var _6 = "_tabSelector-module__tabs-container";
export { _1 as "active", _2 as "container", _3 as "content-container", _4 as "overflow-container", _5 as "tab", _6 as "tabs-container" }
